export const squaresValuePattern = /^\d+(\.\d+)?$|^\d+\/\d+$/;
export const pitchValuePattern = /^\d+$|^\d+\/\d+$|^\d+-\d+$/;

export const LeadSourceOptions = [
  { label: "Customer Referral", value: "Customer Referral" },
  { label: "BBB", value: "BBB" },
  { label: "Canvassing", value: "Canvassing" },
  { label: "YELP", value: "Yelp" },
  { label: "Trucks/Signs", value: "Trucks/Signs" },
  { label: "Phone Book", value: "Phone Book" },
  { label: "Facebook", value: "Facebook" },
  { label: "Website", value: "Website" },
  { label: "Radio", value: "Radio" },
  { label: "Insurance Agent", value: "Insurance Agent" },
  { label: "Interior", value: "Interior" },
];

export const JobTypeOptions = [
  { label: "Residential", value: "Residential" },
  { label: "Commercial", value: "Commercial" },
  { label: "Insurance", value: "Insurance" },
];

export const PriorityOptions = [
  { label: "High", value: "HIGH" },
  { label: "Medium", value: "MEDIUM" },
  { label: "Low", value: "LOW" },
];

export const JobStageOptions = [
  { label: "Lead", value: "LEAD" },
  { label: "Appointment Scheduled", value: "APPOINTMENT_SCHEDULED" },
  { label: "Filling Claim", value: "FILLING_CLAIM" },
  { label: "Waiting on Scope", value: "WAITING_ON_SCOPE" },
  { label: "Supplementing", value: "SUPPLEMENTING" },
  { label: "Estimating", value: "ESTIMATING" },
  { label: "Estimate Sent", value: "ESTIMATE_SENT" },
  { label: "Commercial", value: "COMMERCIAL" },
  { label: "Hold-Signing", value: "HOLD_SIGNING" },
  { label: "Signed Contract", value: "SIGNED_CONTRACT" },
  { label: "Production Review", value: "PRODUCTION_REVIEW" },
  { label: "Lost", value: "LOST" },
  { label: "Material Ordered", value: "MATERIAL_ORDERED" },
  { label: "Secondary Trades", value: "SECONDARY_TRADES" },
  { label: "Job Scheduled", value: "JOB_SCHEDULED" },
  // { label: "Job In Progress", value: "JOB_IN_PROGRESS" },
  { label: "Final Walkthrough", value: "FINAL_WALKTHROUGH" },
  { label: "Job Completed", value: "JOB_COMPLETED" },
  { label: "Invoiced Insurance", value: "INVOICED_INSURANCE" },
  { label: "Invoiced Commercial", value: "INVOICED_COMMERCIAL" },
  { label: "Paid & Closed", value: "PAID_N_CLOSED" },
  { label: "Paid & Happy", value: "PAID_N_HAPPY" },
  { label: "Paid & Left Review", value: "PAID_N_LEFT_REVIEW" },
  {
    label: "DELINQUENT - Do Not Add Jobs",
    value: "DELINQUENT_DO_NOT_ADD_JOBS",
  },
];

export const TradeOptions = [
  { label: "New Roof", value: "NEW_ROOF" },
  { label: "Gutters", value: "GUTTERS" },
  { label: "Siding", value: "SIDING" },
  { label: "Emergency Tarp", value: "EMERGENCY_TARP" },
  { label: "Inspection", value: "INSPECTION" },
  { label: "Repairs", value: "REPAIRS" },
  { label: "Wrapping", value: "WRAPPING" },
  { label: "Windows", value: "WINDOWS" },
  { label: "Interior", value: "INTERIOR" },
];

export const ShingleOptions = [
  { label: "Black", value: "BLACK" },
  { label: "Brown", value: "BROWN" },
  { label: "Gray", value: "GRAY" },
  { label: "White", value: "WHITE" },
  { label: "Red", value: "RED" },
  { label: "Green", value: "GREEN" },
  { label: "Blue", value: "BLUE" },
  { label: "Custom", value: "CUSTOM" },
];

export const CurrentStageOptions = JobStageOptions;

export const PolicyTypeOptions = [
  { label: "Homeowners", value: "HOMEOWNERS" },
  { label: "Commercial", value: "COMMERCIAL" },
  { label: "Renters", value: "RENTERS" },
  { label: "Condo", value: "CONDO" },
];


